import type { FC } from 'react';
import { styled } from 'styled-components';

import type { JobOffer } from '~/business/JobOffer/types';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useAsyncMemo } from '~/hooks';
import { callAcquisitionApiProxy } from '~/utils/acquisition';

const MapWrapper = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.space.layout.y.m};
`;

const Img = styled.img`
  min-width: 100%;
  border-radius: 16px;
`;

export const MissionMap: FC<{ jobOffer: JobOffer }> = ({ jobOffer }) => {
  const { businessUnit } = useBusinessUnitContext();

  const data = useAsyncMemo(async () => {
    try {
      return await callAcquisitionApiProxy({
        businessUnit,
        method: 'getJobOfferStaticMapForJobs',
        body: { jobOfferId: jobOffer.id },
      });
    } catch (e) {
      console.error(e);
    }
  }, [businessUnit, jobOffer.id]);

  return data ? (
    <MapWrapper>
      <Img src={`data:image/jpeg;base64,${data}`} alt={jobOffer.title} />
    </MapWrapper>
  ) : null;
};
